import React from "react";
import DataGrid, {
  Column,
  Selection,
  FilterRow,
  Paging,
  Pager,
  Toolbar,
  Item,
  Lookup,
} from "devextreme-react/data-grid";
import { formatMessage } from "devextreme/localization";
import { Button } from "devextreme-react/button";
import { useScreenSize } from "../../../utils/media-query";
import {
  RequestStatus,
  handleCheckDisableButton,
  changeDisplayedName,
  ApprovalStatus,
  AllowApprove,
} from "../../../common";
import { useAuth } from "../../../contexts/auth";
import ToolbarBefore from "../../../components/toolbar-before/ToolbarBefore";
import ToolbarAfter from "./ToolbarAfter";

export default function OvertimeApprovalTableList({
  dataGrid,
  middleware,
  handleOpenPopup,
  approvalList = [],
  handleChangeSelectBox,
  filter,
  setFilter,
  handleSendApprove,
}) {
  const [selectedItems, setSelectedItems] = React.useState([]);
  const [isDisable, setIsDisable] = React.useState(true);
  const { isXSmall, isSmall } = useScreenSize();
  const { user } = useAuth();

  const selectionPopupChanged = ({ selectedRowsData }) => {
    setSelectedItems(selectedRowsData);
    handleCheckDisableButton(selectedRowsData, setIsDisable, user);
  };

  const renderActions = ({ data }) => {
    // 0: Reject
    // 1: Approve
    const newDataApprove = { ...data, type: 1, category: "OT" };
    const newDataReject = { ...data, type: 0, category: "OT" };

    // ApprovalStatus !== 0,1 show
    // RequestStatus === 0,1 show

    return (
      <>
        {/* {data.ApprovalStatus !== 0 &&
        data.ApprovalStatus !== 1 &&
        (data.RequestStatus === 0 || data.RequestStatus === 1) ? ( */}
        {data?.IsAllowApprove ? (
          <>
            <Button
              type="default"
              stylingMode="outlined"
              // text={formatMessage("Approve")}
              icon="check"
              onClick={() => handleSendApprove(newDataApprove)}
              className="button-rounded mr-2"
            />
            <Button
              type="danger"
              stylingMode="outlined"
              // text={formatMessage("Reject")}
              icon="close"
              className="button-rounded"
              // icon="close"
              onClick={() => handleOpenPopup(newDataReject)}
            />
          </>
        ) : null}
      </>
    );
  };
  return (
    <div>
      <DataGrid
        id="gridContainer"
        showBorders={true}
        showRowLines={true}
        height={
          isXSmall || isSmall
            ? "auto"
            : document.documentElement.offsetHeight - 189
        }
        hoverStateEnabled={true}
        rowAlternationEnabled={true}
        columnAutoWidth={true}
        columnResizingMode="widget"
        alignment="center"
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnHidingEnabled={true}
        dataSource={approvalList}
        ref={(e) => (dataGrid.current = e)}
        onSelectionChanged={selectionPopupChanged}
      >
        <Selection
          mode="multiple"
          selectAllMode="page"
          showCheckBoxesMode="always"
          allowSelectAll={true}
        />
        <FilterRow visible={true} />
        <Paging defaultPageSize={10} />
        <Pager
          showPageSizeSelector={true}
          allowedPageSizes={[10, 20, 50, 100]}
          showInfo={true}
          visible={true}
        />
        {middleware && middleware.ApproveState && (
          <Column
            caption={formatMessage("Action")}
            cellRender={renderActions}
            alignment="center"
            hidingPriority={isXSmall || isSmall ? 4 : false}
          />
        )}
        <Column
          caption={formatMessage("IsAllowApprove")}
          dataField="IsAllowApprove"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        >
          <Lookup
            dataSource={AllowApprove}
            displayExpr={changeDisplayedName()}
            valueExpr="id"
          />
        </Column>

        <Column
          caption={formatMessage("EmployeeCode")}
          dataField="EmployeeCode"
          dataType="string"
          hidingPriority={isXSmall ? 1 : false}
        />
        <Column
          caption={formatMessage("FullName")}
          dataField="FullName"
          dataType="string"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        />
        <Column
          caption={formatMessage("RequestStatus")}
          dataField="RequestStatus"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        >
          <Lookup
            dataSource={RequestStatus}
            displayExpr={changeDisplayedName()}
            valueExpr="id"
          />
        </Column>
        <Column
          caption={formatMessage("DepartmentName")}
          dataField="Department"
          dataType="string"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        />
        <Column
          caption={formatMessage("PositionName")}
          dataField="Position"
          dataType="string"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        />
        <Column
          caption={formatMessage("ShiftName")}
          dataField="ShiftCode"
          dataType="string"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        />

        <Column
          caption={formatMessage("OvertimeDate")}
          dataField="OvertimeDate"
          dataType="date"
          format="dd/MM/yyyy"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        />
        <Column
          caption={formatMessage("IsBreakTime")}
          dataField="IsBreakTime"
          dataType="boolean"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        />
        {/* <Column
          caption={formatMessage("IsBeforeShift")}
          dataField="IsBeforeShift"
          dataType="boolean"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        /> */}
        <Column
          caption={formatMessage("TimeIn")}
          dataField="TimeIn"
          dataType="time"
          hidingPriority={isXSmall || isSmall ? 4 : false}
          format="hh:mm:ss"
          // width={120}
        />
        <Column
          caption={formatMessage("TimeOut")}
          dataField="TimeOut"
          dataType="time"
          hidingPriority={isXSmall || isSmall ? 4 : false}
          format="hh:mm:ss"
          // width={120}
        />
        <Column
          caption={formatMessage("TotalHours")}
          dataField="TotalHours"
          dataType="number"
          hidingPriority={isXSmall || isSmall ? 4 : false}
          // width={120}
        />
        <Column
          caption={formatMessage("Reason")}
          dataField="Reason"
          dataType="string"
          hidingPriority={isXSmall || isSmall ? 4 : false}
          // width={120}
        />
        <Column
          caption={formatMessage("Description")}
          dataField="Description"
          dataType="string"
          hidingPriority={isXSmall || isSmall ? 4 : false}
          // width={120}
        />

        <Column
          caption={formatMessage("CancelReason")}
          dataField="CancelReason"
          dataType="string"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        />
        <Column
          caption={formatMessage("CanceledDate")}
          dataField="CanceledDate"
          dataType="date"
          format="dd/MM/yyyy"
          hidingPriority={isXSmall ? 8 : false}
        />
        <Column
          caption={formatMessage("ApprovalStatus")}
          dataField="ApprovalStatus"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        >
          <Lookup
            dataSource={ApprovalStatus}
            displayExpr={changeDisplayedName()}
            valueExpr="id"
          />
        </Column>
        <Column
          caption={formatMessage("FirstApprovalName")}
          dataField="FirstApprovalName"
          dataType="string"
          hidingPriority={isXSmall ? 8 : false}
        />
        <Column
          caption={formatMessage("ApprovedByName")}
          dataField="LastApprovalName"
          dataType="string"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        />
        <Column
          caption={formatMessage("ApprovedDate")}
          dataField="ApprovedDate"
          dataType="date"
          format="dd/MM/yyyy"
          hidingPriority={isXSmall ? 13 : false}
        />
        <Column
          caption={formatMessage("ApprovalComments")}
          dataField="ApprovalComments"
          dataType="string"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        />
        <Column
          caption={formatMessage("CreatedBy")}
          dataField="CreatedBy"
          hidingPriority={isXSmall || isSmall ? 5 : false}
        />
        <Column
          caption={formatMessage("CreatedDate")}
          dataField="CreatedDate"
          dataType="date"
          format="dd/MM/yyyy"
          hidingPriority={isXSmall || isSmall ? 5 : false}
        />
        <Column
          caption={formatMessage("UpdatedBy")}
          dataField="UpdatedBy"
          hidingPriority={isXSmall || isSmall ? 5 : false}
        />
        <Column
          caption={formatMessage("UpdatedDate")}
          dataField="UpdatedDate"
          dataType="date"
          format="dd/MM/yyyy"
          hidingPriority={isXSmall || isSmall ? 5 : false}
        />
        <Toolbar>
          <Item
            location="before"
            locateInMenu={isXSmall || isSmall ? "always" : "auto"}
            cssClass={"datagrid-toolbar-actions-dropdown"}
          >
            <ToolbarBefore
              middleware={middleware}
              filter={filter}
              setFilter={setFilter}
              handleChangeSelectBox={handleChangeSelectBox}
              handleSendApprove={handleSendApprove}
            />
          </Item>
          <Item
            location="after"
            locateInMenu={isXSmall || isSmall ? "always" : "auto"}
            cssClass={"datagrid-toolbar-actions-dropdown"}
          >
            <ToolbarAfter
              selectedItems={selectedItems}
              middleware={middleware}
              handleOpenPopup={handleOpenPopup}
              dataGrid={dataGrid}
              isDisable={isDisable}
              handleSendApprove={handleSendApprove}
            />
          </Item>
        </Toolbar>
      </DataGrid>
    </div>
  );
}
